/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-03-07 09:32:44
 * @LastEditTime: 2025-04-09 16:12:35
 * @LastEditors: ywj@originqc.com
 */
import React, { useState, useEffect } from "react";
import Header from '../components/header';
import OrderCard from './components/order-card'
import codePic from './imgs/code.png'
import payIcon from './imgs/pay.png'
import chatIcon from './imgs/chat.png'
import cloudIcon from './imgs/cloud.png'
import UModal from '@/components/modal'
import LikeCarousel from '@/components/like-carousel'
import ProcessModal from './components/process-modal'
import TipsModal from './components/tips-modal'
import { createOrder, getPayResult,getOrderById } from '@/api/personal-center'
import { QRCode } from 'antd';
import './index.scss';
import { message } from "antd";
import { useSearchParams,useNavigate } from "react-router-dom";
import useBackToTop from '@/hooks/useBackToTop';
import { clear } from "console";
interface IOrderData {
  totalAmount: string,
  qrcodeUrl: string,
  orderName: string,
  orderNo: string,
  payAmount: string,
  restTime: string,
  id: number,
  receiver: {
    id: number,
    name: string,
    tel: string,
    city: string,
    province: string,
    region: string,
    detailAddress: string,

  },
  billBase:{
    type:number,
    id:number,
    name:string,
    header:string,
  }
}

let apSetTime: ReturnType<typeof setTimeout>; //轮询获取二维码

const Payment: React.FC = () => {
  const [showTipsModal, setShowTipsModal] = useState(false);//订单超时等提示
  const [showProcessModal, setShowProcessModal] = useState(false);//对公支付流程
  const [isTimeOut, setIsTimeOut] = useState(false);//超时或订单失效提示弹窗
  const [orderData, setOrderData] = useState<IOrderData>();
  const [paySuccess, setPaySuccess] = useState(false);//提交成功
  const [time, setTime] = useState<number>();
  const [payFail, setPayFail] = useState(false);
  const [payFailRea, setPayFailRea] = useState<string>('');
  const { scrollToTop } = useBackToTop(300); // 调用自定义 Hook
  const [searchParams] = useSearchParams();
  // 获取 订单id 参数
  const orderId = searchParams.get('orderId');

  const navigate = useNavigate();
  useEffect(() => {
    // getOrderById({id:orderId}).then((res: any) => {
    //   if (res.success) {
    //     setOrderData(res.obj);
    //   } else { 
    //     message.error(res.message);
    //   }
    // });
    handleOrderById();
  }, []);
  const handleOrderById = () => {
    getOrderById({id:orderId}).then((res: any) => {
      if (res.success) {
        setOrderData(res.obj);
        if (res.obj?.restTime === null) { 
          clearTimeout(apSetTime);
        }
      } else { 
        message.error(res.message);
      }
    });
  }
  useEffect(() => {
    scrollToTop();
  }, [])
  useEffect(() => {
    if (orderData&&Object.keys(orderData).length>0&&time === 0) { //超时，提示订单失效
      // handleOrderById();
      // setIsTimeOut(true);
      setShowProcessModal(false);
      clearTimeout(apSetTime);
    }
  }, [orderData,time]);
  useEffect(() => {
    if (!isTimeOut) {
      if ((orderData && Number(orderData?.totalAmount) < 300000)) {
        handleIntTime();
        return () => {
          clearTimeout(apSetTime);
        };
      }
    } else { 
      clearTimeout(apSetTime);
    }
   
    
  }, [orderData,isTimeOut]);


  const handleCancel = () => {
    setShowTipsModal(false)
  }

// 监听浏览器tab切换，调取接口，获取最新的定时器时间
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        handleOrderById();
        // 执行你的代码，例如发送数据到服务器
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handleOrderById]);
  useEffect(() => { 
    if (isTimeOut ||time === 0) {
      clearTimeout(apSetTime);
  }
  },[isTimeOut])
  // 定时查询扫码支付结果
  const handleIntTime = () => {
    if (orderData) {
      // 在设置新的定时器之前，先清除之前的定时器
      clearTimeout(apSetTime);
      apSetTime = setTimeout(() => {
        getPayResult(orderData.orderNo).then((res: any) => {
          if (res.success) {
            if (res.obj.result_pay === 'notpay') {
              if (!isTimeOut && time !== 0) {
                handleIntTime(); // Recursive call only if not timed out
              }
              // handleOrderById();
            } else {
              clearTimeout(apSetTime);
              if (res.obj.result_pay === 'success') {
                setPaySuccess(true);
                // setPayWay(res.obj.payMethod);
                navigate(`/user/payment/success?orderId=${orderId}&payWay=${res.obj.payMethod}`)
              } else {
                message.error(res.obj.result_pay ?? '');
              }
            }
          } else {
            clearTimeout(apSetTime);
            setPayFailRea(res.message ?? '');
            setPayFail(true);
          }
        });
      }, 3000);
    }
  };

  // 对公支付
  const handleBigPay = () => {
    setShowProcessModal(true);
    clearTimeout(apSetTime);//清空扫码结果查询轮询
  };

  const goHome = () => { 
    navigate('/home')
  }

  return <div>
    <Header title="收银台" />
    <div className="payment-container">
      <OrderCard
        orderData={orderData || {} as IOrderData}
        // setPaySuccess={setPaySuccess}
        // paySuccess={paySuccess}
        type='wait'
        setTime={setTime}
        isTimeOut={isTimeOut}
        setIsTimeOut={ setIsTimeOut}
        // payWays={payWay}
      />
      <div className="scan-box">
         <div className="scan-content">
          {(orderData && Number(orderData?.totalAmount) < 300000) && <div>
            <p className="scan-title">扫码支付</p>
            <div className="code-box">
              <QRCode
                bgColor='#fff'
                size={259}
                value={orderData.qrcodeUrl ?? 'https://qr.alipay.com/bax03389tbbzb18kxg7b0017'}
              />
              <div className="code-detail">
                <p className="money">￥{orderData?.payAmount}</p>
                <p className="pay-text">支持支付宝/微信/云闪付扫码支付
                  <img src={payIcon} alt="支付宝" />
                  <img src={chatIcon} alt="微信" />
                  <img src={cloudIcon} alt="云闪付" />
                </p>
              </div>
            </div>
            <p className="scan-title">其他方式</p>
          </div>}
          <div className="pay-btn" onClick={handleBigPay}>
            对公支付

          </div>
        </div>
          
      </div>

    </div>

    <TipsModal
      isTimeOut={isTimeOut}
      setIsTimeOut={setIsTimeOut}
      title='订单支付超时，请重新下单支付'
      type='timeOut'
    />
    {/* 支付错误 */}
    <TipsModal
      isTimeOut={payFail}
      setIsTimeOut={setPayFail}
      title={payFailRea}
      type='fail'
    />
    <ProcessModal
      setShowProcessModal={setShowProcessModal}
      showProcessModal={showProcessModal}
      orderData={orderData || {} as IOrderData}
      type='payment'
      // setPaySuccess={setPaySuccess}
      // setPayWay={setPayWay}
    />
  </div>;
}

export default Payment;
